import React, { useContext } from 'react';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import RequestResult from '../RequestResult/RequestResult';

const VehiclePart6 = () => {
  const [formData] = useContext(FormDataContext);

  React.useEffect(() => {
    console.log('Part 6');
  }, []);

  return (
    <div>
      <RequestResult result={formData.referenceNumber ? 'A' : 'E'} final />
    </div>
  );
};

export default VehiclePart6;
